<template lang="pug">
  div
    table.table.table-striped.table-bordered
      tr
        td Вид исследования
        td {{formatAnswer(data.document_subtype_text, 2)}}
      tr
        td Название исследования
        td {{formatAnswer(data.title, 2)}}
      tr
        td Номер исследования
        td {{formatAnswer(data.body.content.number, 2)}}
      tr
        td Название медицинского аппарата
        td {{formatAnswer(data.body.content.device_name, 2)}}
      tr
        td Суммарная эффективная радиационная доза
        td {{formatAnswer(data.body.content.radiation_effective_dose, 5, " мЗв")}}
      tr
        td Дата контрольного исследования
        td
          span(v-if="data.body.content.follow_up_test_date!==undefined") {{data.body.content.follow_up_test_date | date}}
          span(v-if="data.body.content.follow_up_test_date===undefined") —
      tr(v-if="data.title.value !== 'ЭКГ'")
        td АД
        td {{formatAnswer(data.body.content.systolic_pressure, 2)}}/{{formatAnswer(data.body.content.diastolic_pressure, 2)}}
      tr(v-if="data.body.content.expiratory_maximum_25 || data.body.content.tiffeneau_index || data.body.content.expiratory_maximum_50 || data.body.content.expiratory_maximum_75 || data.body.content.expiratory_volume || data.body.content.forced_lung_capacity || data.body.content.lung_capacity || data.body.content.pulse_oximetry")
        td Спирометрия
        td
          span(v-if="data.body.content.expiratory_maximum_25") МОС25: {{data.body.content.expiratory_maximum_25}},
          span(v-if="data.body.content.expiratory_maximum_50") МОС50: {{data.body.content.expiratory_maximum_50}},
          span(v-if="data.body.content.expiratory_maximum_75") МОС75: {{data.body.content.expiratory_maximum_75}},
          span(v-if="data.body.content.expiratory_volume") ОФВ1: {{data.body.content.expiratory_volume}},
          span(v-if="data.body.content.forced_lung_capacity") ФЖЕЛ: {{data.body.content.forced_lung_capacity}},
          span(v-if="data.body.content.tiffeneau_index") Т/Т: {{data.body.content.tiffeneau_index}},
          span(v-if="data.body.content.lung_capacity") ЖЕЛ: {{data.body.content.lung_capacity}},
          span(v-if="data.body.content.pulse_oximetry") Пульсоксиметрия (SaO2%): {{data.body.content.pulse_oximetry}}
      tr(v-if="data.title == 'ЭКГ'")
        td Данные ЭКГ
        td(v-if="data.body.content.systolic_pressure || data.body.content.diastolic_pressure || data.body.content.heart_rate || data.body.content.P || data.body.content.PQ || data.body.content.QRS || data.body.content.QT || data.body.content.RR")
          span(v-if="data.body.content.systolic_pressure || data.body.content.diastolic_pressure") АД {{formatAnswer(data.body.content.systolic_pressure, 2)}}/{{formatAnswer(data.body.content.diastolic_pressure, 2)}},&nbsp;
          span(v-if="data.body.content.heart_rate") ЧСС: {{data.body.content.heart_rate}},&nbsp;
          span(v-if="data.body.content.P") P: {{data.body.content.P}},&nbsp;
          span(v-if="data.body.content.PQ") PQ: {{data.body.content.PQ}},&nbsp;
          span(v-if="data.body.content.QRS") QRS: {{data.body.content.QRS}},&nbsp;
          span(v-if="data.body.content.QT") QT: {{data.body.content.QT}},&nbsp;
          span(v-if="data.body.content.RR") RR: {{data.body.content.RR}}
        td(v-if="!data.body.content.systolic_pressure && !data.body.content.diastolic_pressure && !data.body.content.heart_rate && !data.body.content.P && !data.body.content.PQ && !data.body.content.QRS && !data.body.content.QT && !data.body.content.RR") —
      tr
        td Описание
        td {{formatAnswer(data.body.content.description, 2)}}
      tr(v-if="data.body.content.method")
        td Описание метода
        td {{formatAnswer(data.body.content.method, 2)}}
      tr(v-if="data.body.content.features")
        td Особенности
        td {{formatAnswer(data.body.content.features, 2)}}
      tr(v-if="data.body.content.total_calcium_index")
        td Суммарный кальциевый индекс
        td {{formatAnswer(data.body.content.total_calcium_index, 2)}}
      tr(v-if="data.body.content.esophagus")
        td Пищевод
        td {{formatAnswer(data.body.content.esophagus, 2)}}
      tr(v-if="data.body.content.stomach")
        td Желудок
        td {{formatAnswer(data.body.content.stomach, 2)}}
      tr(v-if="data.body.content.gut")
        td 12-ти перстная кишка
        td {{formatAnswer(data.body.content.gut, 2)}}
      tr(v-if="data.body.content.therapeutic_manipulations")
        td Лечебные манипуляции
        td {{formatAnswer(data.body.content.therapeutic_manipulations, 2)}}
      tr(v-if="data.body.content.histological_biopsy")
        td Отметка о биопсии на гистологию
        td {{formatAnswer(data.body.content.histological_biopsy, 2)}}
      tr(v-if="data.body.content.nbp_biopsy")
        td Отметка о биопсии на НВП
        td {{formatAnswer(data.body.content.nbp_biopsy, 2)}}
      tr
        td Заключение
        td {{formatAnswer(data.body.content.conclusion, 2)}}
</template>
<script>
export default {
  props: ['data'],

  methods: {
    formatAnswer (fact, type, units) {
      switch (type) {
        case 1:
          return fact !== undefined ? (fact ? 'Да' : 'Нет') : '—'
        case 2:
          return fact || '—'
        case 3:
          return fact ? fact.name : '—'
        case 5:
          return fact ? fact + units : '—'
        case 6:
          return fact ? units + fact : ''
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
</style>
